import { AppStoreCTA } from "../components/AppStoreCTA";
import { GameButton } from "../components/GameButton";
import { NumgnumCard } from "../components/NumgnumCard";

export function HomePage() {
  return (
    <div className="home-page home-page--continuous">
      <article className="continuous-story" aria-label="Journey through the world of NUMGNUMS">
        <div className="continuous-story__backdrop" aria-hidden="true">
          <picture>
            <source srcSet="/art/scenes/continuous-forge-island-scroll-v3-wide.avif" type="image/avif" />
            <img
              src="/art/scenes/continuous-forge-island-scroll-v3.webp"
              srcSet="/art/scenes/continuous-forge-island-scroll-v3.webp 864w, /art/scenes/continuous-forge-island-scroll-v3-2x.webp 1728w"
              sizes="(max-width: 700px) 280vw, 100vw"
              width="2560"
              height="5396"
              loading="eager"
              fetchPriority="high"
              alt=""
            />
          </picture>
          <div className="continuous-story__light" />
          <div className="continuous-story__embers" />
        </div>

        <div className="story-canvas">
          <span className="story-anchor story-anchor--island" id="island" />
          <span className="story-anchor story-anchor--forge" id="founding" />
          <span className="story-anchor story-anchor--arena" id="battle" />
          <span className="story-anchor story-anchor--hoard" id="hoard" />

          <img className="world-prop world-prop--island" src="/art/foreground/island-cliff-perch-side-v1.webp" alt="" aria-hidden="true" />
          <img className="world-prop world-prop--forge" src="/art/foreground/forge-gantry-side-v1.webp" alt="" aria-hidden="true" />
          <img className="world-prop world-prop--arena" src="/art/foreground/arena-spectator-tower-side-v1.webp" alt="" aria-hidden="true" />

          <div className="story-vignette story-vignette--island" aria-hidden="true" />
          <div className="story-vignette story-vignette--forge" aria-hidden="true" />
          <div className="story-vignette story-vignette--arena" aria-hidden="true" />
          <div className="story-vignette story-vignette--hoard" aria-hidden="true" />

          <div className="story-copy story-copy--hero">
            <p className="story-kicker">A free-to-play collectible-card beach RPG</p>
            <h1 className="carved-title"><span>Forge slop.</span><em>Bite back.</em></h1>
            <div className="snark-ribbon">Monster catching is unc. Sloppy sloppy forge slop.</div>
            <p className="story-blurb">Forge weird little legends. Become the forever founder of a new NUMGNUM. Battle friends. Nom their hoards. Keep the good stuff.</p>
            <aside className="anti-nft-note"><strong>These aren't NFTs. Stop asking.</strong> It's just more AI slop bed rot.</aside>
            <div className="hero-actions">
              <GameButton to="/world">Enter Forge Island</GameButton>
              <GameButton to="/account" tone="sea">Open my hoard</GameButton>
              <AppStoreCTA />
            </div>
          </div>

          <div className="free-play-seal free-play-seal--plain" aria-label="Free to play">
            <strong>Free to play</strong><small>App Store soon</small>
          </div>
          <img className="story-creature story-creature--island" src="/art/creatures/numgnaw.webp" alt="Numgnaw charging onto Forge Island" />

          <img className="story-emblem" src="/art/brand/grinning-forge-emblem.webp" alt="The grinning NUMGNUMS forge" />
          <div className="story-copy story-copy--forge">
            <p className="story-kicker">First forge. Forever founder.</p>
            <h2 className="carved-title carved-title--fire"><span>Make worse</span><em>ones.</em></h2>
            <p className="story-blurb">Match two NUMGNUMS. Feed them to the furnace. If that creature-and-edition has never existed, Serial No. 1 leaves the forge with your name fused into it forever.</p>
            <GameButton to="/forge" tone="gold">Start forging slop</GameButton>
          </div>
          <div className="founder-showcase">
            <div className="founder-showcase__card founder-showcase__card--front">
              <span>THE FIRST MISTAKE</span>
              <NumgnumCard level={1} edition="arcade" founder serial={1} founderName="THATCHER" />
            </div>
            <div className="founder-showcase__card founder-showcase__card--back">
              <span>THE PERMANENT RECEIPT</span>
              <NumgnumCard level={1} edition="midnight" founder shiny serial={1} founderName="JOCELYN" initialFlipped />
            </div>
          </div>

          <div className="story-copy story-copy--arena">
            <p className="story-kicker">Feed the fight</p>
            <h2 className="carved-title carved-title--violet"><span>Battle. Bite.</span><em>Steal.</em></h2>
            <p className="story-blurb">Lock in. Choose what is at risk. Play the higher card. Win the match and random cards from your rival become legally sanctioned snacks.</p>
            <GameButton to="/arena" tone="violet">Climb into the arena</GameButton>
          </div>
          <img src="/art/creatures/nibblewick.webp" className="story-creature story-creature--host" alt="NibbleWick ready to battle" />
          <div className="story-bite-seal" aria-hidden="true"><img src="/art/foreground/arena-bite-medallion-v1.webp" alt="" /><span>NOM!</span><small>WIN THE ROUND · TAKE THE BITE</small></div>
          <img src="/art/creatures/chompley.webp" className="story-creature story-creature--rival" alt="Chompley ready to battle" />

          <div className="story-copy story-copy--hoard">
            <p className="story-kicker">Rare slop has a real address</p>
            <h2 className="carved-title carved-title--gold"><span>Own the weird.</span><em>Track the world.</em></h2>
            <p className="story-blurb">Search player hoards. Compare serials. Keep the founder receipts. Watch the real Exchange as it crawls out of the tide.</p>
            <div className="button-row">
              <GameButton to="/discover" tone="sea">Search world records</GameButton>
              <GameButton to="/market" tone="gold">Visit the Exchange</GameButton>
            </div>
          </div>
          <img className="story-creature story-creature--hoard" src="/art/creatures/gobgrin.webp" alt="Gobgrin guarding the hoard" />
          <div className="story-download"><AppStoreCTA /></div>
        </div>
      </article>
    </div>
  );
}
